module.exports = __webpack_public_path__ + "c3a1de9fbbaaa4d5bea0661fad714996.svg";